import { render, staticRenderFns } from "./batchPass.vue?vue&type=template&id=274edc68&scoped=true&"
import script from "./batchPass.vue?vue&type=script&lang=js&"
export * from "./batchPass.vue?vue&type=script&lang=js&"
import style0 from "./batchPass.vue?vue&type=style&index=0&id=274edc68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274edc68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('274edc68')) {
      api.createRecord('274edc68', component.options)
    } else {
      api.reload('274edc68', component.options)
    }
    module.hot.accept("./batchPass.vue?vue&type=template&id=274edc68&scoped=true&", function () {
      api.rerender('274edc68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/audit/category/batchPass.vue"
export default component.exports